import * as React from "react";

import { RenderFunctionType } from "@cak-legacy/generation-core";

export interface OverviewRenderer {
  render?: RenderFunctionType;
}

export const createOverviewRenderer = (hasCustomOverview = false): OverviewRenderer | undefined => {
  return hasCustomOverview
    ? {
        render: () => <></>
      }
    : undefined;
};
